import { PageLink, PageTitle } from "_metronic/layout/core";
import { CPLAnalytics } from "setup/appInsights/CPLAnalytics";
import ServiceChargeInvoicingSummaries from "./components/ServiceChargeInvoicingSummaries";

const serviceChargeSummariesBreadCrumbs: Array<PageLink> = [
  {
    title: "Service Charge Invoice Summaries",
    path: "/ServiceChargeInvoicing",
    isSeparator: false,
    isActive: true,
  },
];

const ServiceChargeInvoicingPage = () => {
  return (
    <CPLAnalytics pageName="Service Charge Invoice Summaries">
      <PageTitle breadcrumbs={serviceChargeSummariesBreadCrumbs}></PageTitle>
      <ServiceChargeInvoicingSummaries />
    </CPLAnalytics>
  );
};

export default ServiceChargeInvoicingPage;
